import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';
import { registerLocaleData } from '@angular/common';
// import { AgmCoreModule } from '@agm/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';

// import {LoginComponent} from './login/login.component';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MaterialModule} from './material/material.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PageModulesComponent} from './page-modules/page-modules.component';
import {NavigationModule} from './navigation/navigation.module';
import {MatIconModule} from '@angular/material/icon';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {InterceptorService} from './services/interceptor.service';
import {DialogoConfirmacionComponent} from 'src/app/custom-components/dialogo-confirmacion/dialogo-confirmacion.component';
import {SnackbarService} from './services/snackbar-service.service';
import {BaseFormComponent} from './custom-components/base-form/base-form.component';
import {BaseTableComponent} from './custom-components/base-table/base-table.component';
import {CustomHeaderModule} from './custom-components/custom-header/custom-header.module';
import {AplicacionModule} from './_module/procesadora/aplicacion-datos/aplicacion/aplicacion.module';
import {AplicacionTipoModule} from './_module/procesadora/aplicacion-datos/aplicacion-tipo/aplicacion-tipo.module';
import {AplicacionVersionModule} from './_module/procesadora/aplicacion-datos/aplicacion-version/aplicacion-version.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SharedModule} from './shared/shared.module';
import {AlertModule} from 'ngx-alerts';
import {environment} from '../environments/environment';
import {AddServerUrlInterceptor} from './_interceptors/add-server-url.interceptor';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
// import { LoginComponent } from './login/login.component';
import { LoginModule } from './login/login.module';
import { PasswordRestaurarComponent } from './password-restaurar/password-restaurar.component';

import localePy from '@angular/common/locales/es-PY';
import { EmisorServicioOperacionFormComponent } from './_module/procesadora/emisor-servicio-operacion/emisor-servicio-operacion-form/emisor-servicio-operacion-form.component';
import { TransaccionTipoFormComponent } from './_module/procesadora/transaccion-tipo/transaccion-tipo-form/transaccion-tipo-form.component';
import { ApikeysRoutingModule } from './_module/procesadora/apikeys/apikeys-routing.module';
import { VentasComercioRoutingModule } from './_module/procesadora/fraccionate/ventas-comercio/ventas-comercio-routing.module';
import { ClienteComercioRoutingModule } from './_module/procesadora/fraccionate/clientes-comercio/cliente-comercio-routing.module';
import { FraccionamientoRoutingModule } from './_module/entidad/fraccionate/fraccionamiento/fraccionamiento-routing.module';
import { ClientesEntidadRoutingModule } from './_module/entidad/fraccionate/clientes-entidad/clientes-entidad-routing.module';
import { VentasEntidadRoutingModule } from './_module/entidad/fraccionate/ventas-entidad/ventas-entidad-routing.module';
registerLocaleData(localePy, 'es-PY');
/////////////////////////// angular fire////////////////////////////////////////////////////////////
import { AngularFireModule } from '@angular/fire';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { PageModulesModule } from './page-modules/page-modules.module';
import { RecuperarPasswordModule } from './recuperar-password/recuperar-password.module';
@NgModule({
  declarations: [
    AppComponent,
    // LoginComponent,
    PageModulesComponent,
    BaseFormComponent,
    BaseTableComponent,
    PasswordRestaurarComponent,
    //TransaccionTipoFormComponent,
    //EmisorServicioOperacionFormComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FlexLayoutModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    NavigationModule,
    // PersonaModule,
    HttpClientModule,
    CustomHeaderModule,
    AplicacionModule,
    AplicacionTipoModule,
    AplicacionVersionModule,
    LoginModule,
    SharedModule,
    AlertModule.forRoot({maxMessages: 5, timeout: 5000, positionX: 'right', positionY: 'top'}),
    ApikeysRoutingModule,
    VentasComercioRoutingModule,
    ClienteComercioRoutingModule,
    FraccionamientoRoutingModule,
    ClientesEntidadRoutingModule,
    VentasEntidadRoutingModule,
    //ComercioRoutingModule,
    //ComercioVerificarRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireMessagingModule,
    PageModulesModule,
    RecuperarPasswordModule 

  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'es-PY'
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService, multi: true,
    },
    {provide: MAT_DATE_LOCALE, useValue: 'es-PY'},
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
    {provide: 'BASE_API_URL', useValue: environment.apiUrl},
    {provide: 'BASE_APP_ID', useValue: environment.appId},
    {provide: HTTP_INTERCEPTORS, useClass: AddServerUrlInterceptor, multi: true},
    SnackbarService,
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    DialogoConfirmacionComponent
  ]
})
export class AppModule {
}
